import React from 'react';
import Slider from 'react-slick';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { Row, Col, Card } from 'antd';
import Loader from '../Loader';

const intl = {
  headline: {
    'en': 'What\'s new',
    'dk': 'Nyheder'
  }
}

function Article(props) {
  return (
    <Link to={`/blog/${props.id}`} className="blog-post-card-container">
      <Card style={{ width: '100%', border: 'none', borderRadius: 0 }} bodyStyle={{ padding: 0 }}>
        <div
          className="custom-image"
          style={{
            width: '100%',
            height: '260px',
            background: `url(${props.coverImage}) no-repeat top center`,
            backgroundSize: 'cover',
          }}
        />
        <div className="article-bottom" style={{ textAlign: 'left', padding: '20px' }}>
          <span>{moment(props.createTime).format('MMMM Do, YYYY')}</span>
          <h3 style={{ fontSize: '16px', lineHeight: '20px' }}>{props.title}</h3>
          <p>
            {props.bodyText.substring(0, 150)}...
          </p>
        </div>
      </Card>
    </Link>
  );
}
function Carousel(props) {
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    className: 'carousel',
    responsive: [
      { breakpoint: 768, settings: { slidesToShow: 3 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };
  return (
    <Row style={{ backgroundColor: '#fff', padding: '50px 0' }}>
      <Col sm={24} md={{ span: 12, offset: 6 }}>
        <div style={{ padding: '20px 10px 20px' }}>
          <hr
            style={{
              border: 'none',
              borderTop: '1px solid #1ABC9C',
            }}
          />
          <div
            style={{
              color: '#1ABC9C',
              backgroundColor: '#fff',
              display: 'inline-block',
              /* position: absolute, */
              padding: '0 20px',
              top: '-25px',
              position: 'relative',
              fontSize: '20px',
            }}
          >
            {intl.headline[props.language]}
          </div>
        </div>
      </Col>
      <Col md={{ span: 12, offset: 6 }}>
        {props.loading
          ? <Loader />
          : <Slider {...settings}>
            {Object.keys(props.data).map((key) => (
              <div key={props.data[key].id} style={{ padding: '10px' }}>
                <Article {...props.data[key]} />
              </div>
            ))}
          </Slider>}
      </Col>
    </Row>
  );
}

export default Carousel;

Carousel.defaultProps = {
  data: {},
}


// WEBPACK FOOTER //
// ./src/components/Carousel/index.js